import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const CompleteMemberConciergeOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: {
      variant: 'h1',
      weight: 'medium',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => Text,
    _customProps: {
      variant: 'h4',
      weight: 'medium',
      color: 'primaryGray2',
      lineHeight: 'medium',
    },
  }, overrideReadOnly)
  .nameOverride('meetingDateAndTimeInformation', {
    _component: () => Text,
    _customProps: {
      variant: 'h4',
      weight: 'extraBold',
      color: 'primaryGray2',
      align: 'center',
    },
  }, overrideReadOnly);

export default CompleteMemberConciergeOverride;
